module.exports = __webpack_public_path__ + "media/app/assets/mailers/twitter-light-ba037369a21a623b8302e258e53978ea.png";